<template>
  <div>
    <em
      v-if="hasFontIcon"
      class="eu-mr_1 uil"
      :class="computedFontIcon.name"
      :transform="computedFontIcon.transform"
      data-testid="font-icon"
    />
    <emerald-icon
      v-else-if="iconName === 'pix'"
      icon="pix-outline"
      class="eu-mr_1"
      style="max-width: unset; height: 18px; color: #595a63"
      data-testid="emerald-icon-pix"
    />
    <emerald-icon
      v-else-if="iconName === 'others'"
      icon="ellipsis"
      class="eu-mr_1"
      style="width: 16px; height: 16px"
      data-testid="emerald-icon-others"
    />
    <div
      v-else-if="showTippy"
      class="eu-ml_1"
      data-testid="dash-progress"
    >
      <emd-tippy
        :id="tooltipId"
        :data-template="tooltipId"
        :key="dataType"
        position="top"
        aria-expanded="true"
        type="html"
        data-testid="emd-tippy-dash-info-icon"
      >
        <em class="emd-text _color_success uil uil-info-circle" />
        <emd-tippy-template-HTML :id="tooltipId">
          <emd-text
            v-for="item in tooltipList"
            :key="item.name"
            size="tiny"
            data-testid="emd-text-dash-info-icon"
          >
            {{ $t(item.name) }}
            <b
              v-if="item.percentage || item.value"
              class="_type_bold"
              >: {{ getValue(item) }}</b
            >
            <br />
          </emd-text>
        </emd-tippy-template-HTML>
      </emd-tippy>
    </div>
  </div>
</template>

<script>
import {
  EmdText,
  EmdTippy,
  EmdTippyTemplateHTML,
  EmeraldIcon
} from 'emerald-vue/src/components'

import { DASHBOARD_DATA_TYPE_ENUM } from '../../../../enums/dash-progress-data-type.enum'
import { PAYMENT_METHODS_ICONS } from '../../../../enums/payment-methods-icons.enum'

export default {
  name: 'PaymentMethodIcons',

  components: {
    EmeraldIcon,
    EmdText,
    EmdTippy,
    EmdTippyTemplateHTML
  },

  props: {
    iconName: {
      type: String,
      required: true,
      validation: icon => Object.keys(PAYMENT_METHODS_ICONS).includes(icon)
    },
    tooltipList: {
      type: Array,
      default: () => []
    },
    tooltipId: {
      type: String,
      default: 'paymentMothodsIcons_info-tippy'
    },
    dataType: {
      type: String,
      default: () => DASHBOARD_DATA_TYPE_ENUM.PERCENTAGE,
      validation: type => Object.keys(DASHBOARD_DATA_TYPE_ENUM).includes(type)
    }
  },

  computed: {
    computedFontIcon () {
      return PAYMENT_METHODS_ICONS[this.iconName]
    },
    hasFontIcon () {
      return this.computedFontIcon?.name ?? false
    },
    showTippy () {
      return this.iconName.includes('tooltip') && this.tooltipList?.length > 0
    }
  },

  methods: {
    getValue ({ percentage, value }) {
      return this.dataType === DASHBOARD_DATA_TYPE_ENUM.PERCENTAGE
        ? percentage + '%'
        : value
    }
  }
}
</script>
